<template>
  <div class="v-slider">
    <swiper
      class="swiper"
      :options="swiperOptions"
      @slideChange="$emit('slideChange')"
      ref="swiper">
      <slot />
      <template v-if="navigation">
        <div class="swiper-button-prev d-none d-md-flex" slot="button-prev"></div>
        <div class="swiper-button-next d-none d-md-flex" slot="button-next"></div>
      </template>
      <div v-show="pagination" class="swiper-pagination" slot="pagination"></div>
    </swiper>
  </div>
</template>

<script>
import { Swiper, SwiperSlide } from "vue-awesome-swiper";
import "swiper/css/swiper.css";

export default {
  props: {
    navigation: {
      type: Boolean,
      default: true
    },
    pagination: {
      type: Boolean,
      default: true
    }
  },
  computed: {
    swiper() {
      return this.$refs.swiper.$swiper;
    }
  },
  components: {
    Swiper,
    SwiperSlide
  },
  data() {
    return {
      swiperOptions: {
        navigation: {
          nextEl: ".swiper-button-next",
          prevEl: ".swiper-button-prev"
        },
        pagination: {
          el: ".swiper-pagination",
          clickable: true
        }
      }
    };
  },
  mounted() {
    this.$emit("init");
  }
};
</script>
<style scoped lang="scss">
@import "../../sass/component.scss";

.v-slider::v-deep .swiper {
  &-button {
    &-prev,
    &-next {
      height: calc(100% - 26px);
      width: 50%;
      top: 0;
      margin-top: 0;

      &::after {
        content: "";
        display: block;
        width: 34px;
        height: 34px;
        background-image: url("./assets/next.svg");
        background-size: contain;
        opacity: 0;
        transition: 200ms opacity ease-out;
      }

      &:hover {
        &::after {
          opacity: 1;
        }
      }
    }

    &-prev {
      left: 0;
      justify-content: flex-start;

      &::after {
        transform: rotate(180deg);
      }
    }

    &-next {
      right: 0;
      justify-content: flex-end;
    }

    &-disabled {
      display: none;
    }
  }

  &-pagination {
    position: relative;
    bottom: 0;
    height: 26px;

    &-bullet {
      background-color: theme-color("gray");
      width: 6px;
      height: 6px;
      opacity: 1;

      &-active {
        background-color: theme-color("dark");
      }
    }
  }
}
</style>
